<div *ngrxLet="itemInEdit$ as itemInEdit" [id]="field.id">
  <div class="vstack gap-2 mb-2">
    <ng-container
      *ngFor="let group of field.fieldGroup; index as i; last as last"
    >
      <div *ngIf="i !== itemInEdit" class="bg-primaryLow rounded-1 border p-3">
        <div class="d-flex justify-content-end">
          <div class="hstack gap-1">
            <button luiCab (click)="onDeleteAt(i)">
              <mat-icon svgIcon="trash"></mat-icon>
            </button>
            <button luiCab (click)="onEditAt(i)">
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          </div>
        </div>

        <table *ngIf="group.fieldGroup" class="w-100">
          <ng-container
            *ngTemplateOutlet="
              fieldIterator;
              context: {
                fieldGroup: group.fieldGroup,
                relativeModel: group.model
              }
            "
          ></ng-container>
        </table>
      </div>

      <formly-field *ngIf="i === itemInEdit" [field]="group"></formly-field>
    </ng-container>
  </div>

  <div class="d-flex justify-content-between">
    <div>
      <button
        *ngIf="itemInEdit"
        luiButton
        type="button"
        (click)="onCancelClick(itemInEdit)"
        >Cancel</button
      >
    </div>
    <div>
      <button
        luiButton
        type="button"
        (click)="onAddAnotherClick()"
        *ngIf="itemInEdit | isNil; else saveButton"
      >
        {{ props.addAnotherText || 'Add Another' }}
      </button>
      <ng-template #saveButton>
        <button luiButton type="button" (click)="onSaveClick()">{{
          isEditingExistingItem
            ? props.editText || 'Save changes'
            : props.saveText || 'Save'
        }}</button>
      </ng-template>
    </div>
  </div>
</div>

<ng-template
  #fieldIterator
  let-fieldGroup="fieldGroup"
  let-relativeModel="relativeModel"
>
  <ng-container *ngFor="let row of fieldGroup">
    <ng-container *ngIf="row.key">
      <ng-container *ngIf="relativeModel | get : $any(row.key) as value">
        <tr>
          <td *ngIf="row.type !== 'array'">{{ row.props?.label }}</td>
          <td class="fw-b">
            <ng-container>
              <ng-container [ngSwitch]="row.type">
                <ng-container *ngSwitchCase="'datepicker'">
                  {{ value | date : 'dd/MM/yyyy' }}
                </ng-container>
                <ng-container *ngSwitchCase="'address'">
                  {{ value | address }}
                </ng-container>
                <ng-container *ngSwitchCase="'array'"> </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ value || '-' }}
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="row.fieldGroup && row.fieldGroup.length">
      <ng-container
        *ngTemplateOutlet="
          fieldIterator;
          context: {
            fieldGroup: row.fieldGroup,
            relativeModel: relativeModel
          }
        "
      ></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
